import "./polyfills";

import * as Pages from "./pages";
import "./vendors";
import GameLogic from "./core/game-logic";

/* Entry script */
window.screenCalculationFunc = null;

//Pages object
Object.keys(Pages).forEach((key) => Pages[key]());

//Start game init
GameLogic.init();
